import {useSelector} from 'react-redux';

const useIsRole = (role) => {
    const groups = useSelector((state) => state.user.securityGroups);
    return !!(groups?.length > 0 && groups.some(it => it.name === role))
}

export default useIsRole
